import { Decorators, EntityDialog, WidgetProps } from "@serenity-is/corelib";
import { EmailQueueRow, EmailQueueForm, EmailQueueService, EmailQueueStatus } from "../ServerTypes/Pro";

@Decorators.registerClass('Serenity.Pro.EmailQueue.EmailQueueDialog')
export class EmailQueueDialog<P = {}> extends EntityDialog<EmailQueueRow, P> {
    protected getFormKey() { return EmailQueueForm.formKey; }
    protected getRowDefinition() { return EmailQueueRow; }
    protected getService() { return EmailQueueService.baseUrl; }

    protected form = new EmailQueueForm(this.idPrefix);

    constructor(props: WidgetProps<P>) {
        super(props);

        this.form.Status.changeSelect2(e => {
            if (this.form.Status.value == EmailQueueStatus.InQueue.toString()) {
                this.form.RetryCount.value = 0;
                this.form.LockExpiration.valueAsDate = new Date();
            }
        });
    }
}